module.exports = __webpack_public_path__ + "media/assets/images/card-19c0408833ba83c46a86739ec16bbd19.png";